export const iconFontAwesomeEnergyPlugCircleMinus = (
	<i className="fa-solid fa-plug-circle-minus"></i>
);
